import { useState } from 'react'

import { http, sdkAnalytics } from '@itau-loans-www/services'
import { isClient, getProduct } from '@itau-loans-www/utils'

export const usePendingOfferError = () => {
  const product = getProduct()
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    try {
      setIsLoading(true)
      if (product === 'consignado') {
        sdkAnalytics.track('trackClick', 'btn:nova-simulacao')
      }
      const { url } = await http.proposal.crossSell()

      if (isClient() && BUILD_ENV === 'e2e') {
        return window.location.assign(
          `http://localhost:8000/${url.split('.br/')[1]}`
        )
      }

      isClient() && window.location.assign(url)
    } finally {
      setIsLoading(false)
    }
  }

  return {
    isLoading,
    handleClick
  }
}
